import React, { useEffect, useState, useRef } from 'react';
import { Row, CardBody } from 'reactstrap';
import {
  BaseCardChartContainer,
  BaseChartCardHeaderContainer,
  BaseChartContainer,
  BaseColContainer
} from './common-charts-styles';

export function PercentageProtocolClosed({ closedProtocolsPercentage }) {
  const [validPercentage, setValidPercentage] = useState(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    const closedPercentage = parseFloat(closedProtocolsPercentage);
    if (!isNaN(closedPercentage)) {
      setValidPercentage(closedPercentage);
      updateChart(closedPercentage);
    } else {
      setValidPercentage(null);
    }
  }, [closedProtocolsPercentage]);

  useEffect(() => {
    if (canvasRef.current) {
      updateChart(validPercentage);
    }
  }, [validPercentage]);

  const updateChart = (percentage) => {
    const canvas = canvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext('2d');
      const width = canvas.width;
      const height = canvas.height;
      const openProtocolsPercentage = (100 - percentage).toFixed(2);

      ctx.clearRect(0, 0, width, height);

      const centerX = width / 2;
      const centerY = height / 2;
      const outerRadius = Math.min(width, height) / 2 - 10;
      const innerRadius = outerRadius * 0.6;
      const startAngle = 0;
      const closedAngle = (percentage / 100) * 2 * Math.PI;
      const openAngle = (openProtocolsPercentage / 100) * 2 * Math.PI;

      ctx.beginPath();
      ctx.arc(
        centerX,
        centerY,
        outerRadius,
        startAngle,
        startAngle + closedAngle,
        false
      );
      ctx.arc(
        centerX,
        centerY,
        innerRadius,
        startAngle + closedAngle,
        startAngle,
        true
      );
      ctx.closePath();
      ctx.fillStyle = '#FF6384';
      ctx.fill();

      ctx.beginPath();
      ctx.arc(
        centerX,
        centerY,
        outerRadius,
        startAngle + closedAngle,
        startAngle + closedAngle + openAngle,
        false
      );
      ctx.arc(
        centerX,
        centerY,
        innerRadius,
        startAngle + closedAngle + openAngle,
        startAngle + closedAngle,
        true
      );
      ctx.closePath();
      ctx.fillStyle = '#36A2EB';
      ctx.fill();

      ctx.restore();
      const fontSize = (height / 200).toFixed(2);
      ctx.font = `bold ${fontSize}em sans-serif`;
      ctx.textBaseline = 'middle';
      const text = `${percentage.toFixed(2)}%`;
      const textX = Math.round((width - ctx.measureText(text).width) / 2);
      const textY = height / 2 - 10;
      ctx.fillStyle = '#FF6384';
      ctx.fillText(text, textX, textY);
      ctx.font = `${(fontSize / 1.5).toFixed(2)}em sans-serif`;
      const subText = 'Fechados';
      const subTextX = Math.round((width - ctx.measureText(subText).width) / 2);
      const subTextY = textY + 30;
      ctx.fillText(subText, subTextX, subTextY);
      ctx.save();
    }
  };

  if (validPercentage === null) {
    return (
      <BaseCardChartContainer>
        <BaseChartCardHeaderContainer>
          <h5 className="h3 mb-0">Protocolos fechados</h5>
        </BaseChartCardHeaderContainer>
        <CardBody>
          <Row>
            <BaseColContainer>
              <BaseChartContainer className="chart">
                <p>Valor inválido</p>
              </BaseChartContainer>
            </BaseColContainer>
          </Row>
        </CardBody>
      </BaseCardChartContainer>
    );
  }

  return (
    <BaseCardChartContainer>
      <BaseChartCardHeaderContainer>
        <h5 className="h3 mb-0">Protocolos fechados</h5>
      </BaseChartCardHeaderContainer>
      <CardBody>
        <Row>
          <BaseColContainer>
            <div
              className="chart"
              style={{
                maxHeight: '400px',
                overflowY: 'auto',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <canvas ref={canvasRef} width="350" height="350" />
            </div>
          </BaseColContainer>
        </Row>
      </CardBody>
    </BaseCardChartContainer>
  );
}
